/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AvailableNumberDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PurchaseNumberRequestDTO } from '../models';
// @ts-ignore
import type { TelephonyNumberOverviewDTO } from '../models';
/**
 * AdminTelephonyApi - axios parameter creator
 * @export
 */
export const AdminTelephonyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelephonyOverviewApiV1AdminTelephonyNumbersGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/telephony/numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/telephony/numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseNumberApiV1AdminTelephonyNumbersPost: async (purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseNumberRequestDTO' is not null or undefined
            assertParamExists('purchaseNumberApiV1AdminTelephonyNumbersPost', 'purchaseNumberRequestDTO', purchaseNumberRequestDTO)
            const localVarPath = `/api/v1/admin/telephony/numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseNumberRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseNumberApiV1AdminTelephonyNumbersPost_2: async (purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseNumberRequestDTO' is not null or undefined
            assertParamExists('purchaseNumberApiV1AdminTelephonyNumbersPost_2', 'purchaseNumberRequestDTO', purchaseNumberRequestDTO)
            const localVarPath = `/api/v1/admin/telephony/numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseNumberRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/reactivate`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/reactivate`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNumberApiV1AdminTelephonyNumbersNumberDelete: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('releaseNumberApiV1AdminTelephonyNumbersNumberDelete', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet: async (areaCode?: string | null, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/telephony/available-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (areaCode !== undefined) {
                localVarQueryParameter['area_code'] = areaCode;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5: async (areaCode?: string | null, limit?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/telephony/available-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (areaCode !== undefined) {
                localVarQueryParameter['area_code'] = areaCode;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/suspend`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/suspend`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/unassign`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7: async (number: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7', 'number', number)
            const localVarPath = `/api/v1/admin/telephony/numbers/{number}/unassign`
                .replace(`{${"number"}}`, encodeURIComponent(String(number)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTelephonyApi - functional programming interface
 * @export
 */
export const AdminTelephonyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTelephonyApiAxiosParamCreator(configuration)
    return {
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TelephonyNumberOverviewDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.getTelephonyOverviewApiV1AdminTelephonyNumbersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TelephonyNumberOverviewDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.purchaseNumberApiV1AdminTelephonyNumbersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.purchaseNumberApiV1AdminTelephonyNumbersPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.releaseNumberApiV1AdminTelephonyNumbersNumberDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableNumberDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableNumberDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode, limit, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelephonyNumberOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminTelephonyApi.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminTelephonyApi - factory interface
 * @export
 */
export const AdminTelephonyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTelephonyApiFp(configuration)
    return {
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TelephonyNumberOverviewDTO>> {
            return localVarFp.getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
         * @summary Get Telephony Overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TelephonyNumberOverviewDTO>> {
            return localVarFp.getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
         * @summary Purchase Number
         * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Entsperren: add an owned number back to the LiveKit trunk.
         * @summary Reactivate Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
         * @summary Release Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableNumberDTO>> {
            return localVarFp.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
         * @summary Search Available Numbers
         * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
         * @param {number} [limit] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableNumberDTO>> {
            return localVarFp.searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode, limit, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Sperren: remove the number from the LiveKit trunk (ownership kept).
         * @summary Suspend Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TelephonyNumberOverviewDTO> {
            return localVarFp.suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Freigeben: drop the organization assignment and park the number.
         * @summary Unassign Number
         * @param {string} number 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminTelephonyApi - object-oriented interface
 * @export
 * @class AdminTelephonyApi
 * @extends {BaseAPI}
 */
export class AdminTelephonyApi extends BaseAPI {
    /**
     * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
     * @summary Get Telephony Overview
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).getTelephonyOverviewApiV1AdminTelephonyNumbersGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Live overview merging Twilio ownership, LiveKit routing and DB assignment.
     * @summary Get Telephony Overview
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).getTelephonyOverviewApiV1AdminTelephonyNumbersGet_1(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
     * @summary Purchase Number
     * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).purchaseNumberApiV1AdminTelephonyNumbersPost(purchaseNumberRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kaufen: buy at Twilio, attach to the SIP trunk, optionally assign + route.
     * @summary Purchase Number
     * @param {PurchaseNumberRequestDTO} purchaseNumberRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO: PurchaseNumberRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).purchaseNumberApiV1AdminTelephonyNumbersPost_2(purchaseNumberRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Entsperren: add an owned number back to the LiveKit trunk.
     * @summary Reactivate Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Entsperren: add an owned number back to the LiveKit trunk.
     * @summary Reactivate Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).reactivateNumberApiV1AdminTelephonyNumbersNumberReactivatePost_3(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
     * @summary Release Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).releaseNumberApiV1AdminTelephonyNumbersNumberDelete(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löschen: remove LiveKit routing, release at Twilio, delete the DB record.
     * @summary Release Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).releaseNumberApiV1AdminTelephonyNumbersNumberDelete_4(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
     * @summary Search Available Numbers
     * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet(areaCode, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search purchasable German (DE) numbers, optionally filtered by Vorwahl.
     * @summary Search Available Numbers
     * @param {string | null} [areaCode] German Vorwahl, with or without leading 0 (e.g. 030 or 30)
     * @param {number} [limit] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode?: string | null, limit?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).searchAvailableNumbersApiV1AdminTelephonyAvailableNumbersGet_5(areaCode, limit, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sperren: remove the number from the LiveKit trunk (ownership kept).
     * @summary Suspend Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sperren: remove the number from the LiveKit trunk (ownership kept).
     * @summary Suspend Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).suspendNumberApiV1AdminTelephonyNumbersNumberSuspendPost_6(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freigeben: drop the organization assignment and park the number.
     * @summary Unassign Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freigeben: drop the organization assignment and park the number.
     * @summary Unassign Number
     * @param {string} number 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTelephonyApi
     */
    public unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminTelephonyApiFp(this.configuration).unassignNumberApiV1AdminTelephonyNumbersNumberUnassignPost_7(number, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

